import RecruiterLayout from "@/components/RecruiterLayout";
import { Mail } from "@/components/mail";

export default function EmailInbox() {
  return (
    <RecruiterLayout>
      <div className="h-[calc(100vh-4rem)]">
        <Mail />
      </div>
    </RecruiterLayout>
  );
}
